import { PropertyMapper } from '../../core/decorators';
import { Lot } from '../../core/models';

export class DashboardLot extends Lot {

    @PropertyMapper({ jsonProperty: 'formatted' })
    public formatted: any;
}
